<template>
  <form-wrapper @submit="onSubmit">
    <div slot="box" v-loading="loading">
      <form-header v-if="!inModal" />
      <el-form-item label="Tytuł" :error="errors['title']" required>
        <el-input v-model="form['title']" />
      </el-form-item>
      <el-form-item
        label="Tekst alternatywny (dla czytników)"
        :error="errors['alt']"
      >
        <el-input v-model="form['alt']" />
      </el-form-item>
      <div>
        <h2>Zdjęcie</h2>
        <image-point v-model="form.ppoi" :src="form.file_url" />
        <p>Aby zmienić zdjęcie</p>
        <upload-tab @submit="changeImage" />
      </div>
    </div>
    <form-sidebar
      :loading="loading"
      slot="sidebar"
      @submit="onSubmit"
      :inModal="inModal"
      :redirectRoute="redirectRoute"
    />
  </form-wrapper>
</template>
<script>
import { Image } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import UploadTab from '@/components/inputs/ImageDialog/UploadTab'
import ImagePoint from './ImagePoint'

export default {
  mixins: [FormMixin],
  components: {
    UploadTab,
    ImagePoint
  },
  data() {
    return {
      redirectRoute: { name: 'Image List' }
    }
  },
  methods: {
    changeImage(image) {
      if (!image) return
      this.$set(this.form, 'file', image)
      this.updateImagePreview()
    },
    updateImagePreview() {
      const value = this.form.file
      const fileType = typeof value
      if (fileType === 'object') {
        const reader = new FileReader()
        reader.onload = e => {
          this.$set(this.form, 'file_url', e.target.result)
        }
        reader.readAsDataURL(this.form.file)
      }
    }
  },
  computed: {
    service() {
      return Image
    }
  }
}
</script>
